<template>
  <div class="fc-popup-mask" v-show="localVisible && isReady" @click.self="close">
    <transition @after-leave="onAfterLeave">
      <component
        :is="type"
        :env="env"
        :title="title"
        :subtitle="subtitle"
        :imageUrl="imageUrl"
        :slug="slug"
        :buttonText="buttonText"
        :buttonIcon="buttonIcon"
        :cancelButtonText="cancelButtonText"
        @callback="callback"
        @close="close"
        @cancel="cancel"
        @confirm-callback="confirmCallback"
      >
        <slot />
      </component>
    </transition>
  </div>
</template>
<script>
import Alert from './views/alert';
import Confirm from './views/confirm';
import Notice from './views/notice';
import Custom from './views/custom';

export default {
  name: 'popup',
  components: { Confirm, Alert, Notice, Custom },
  props: [
    'type',
    'visible',
    'env',
    'title',
    'subtitle',
    'slug',
    'imageUrl',
    'buttonText',
    'cancelButtonText',
    'buttonIcon',
  ],
  data() {
    return {
      localTitle: this.title,
      localSubtitle: this.subtitle,
      localVisible: this.visible,
    };
  },
  computed: {
    isReady() {
      let state = true;

      if (this.type === 'alert' && this.getCookie('fc_promotion_popup')) {
        state = false;
      }

      return state;
    },
  },
  methods: {
    onAfterLeave() {
      console.log('onAfterLeave');
    },
    cancel() {
      this.$emit('cancel');
    },
    callback() {
      this.$emit('callback');
    },
    confirmCallback() {
      this.$emit('confirm-callback');
    },
    close() {
      this.localVisible = false;
      this.$emit('close');
    },
    getCookie(key) {
      let localKey = this.slug || key;
      const cookieValue = document.cookie.split('; ').find((row) => row.startsWith(localKey));

      if (cookieValue) {
        return cookieValue.split('=')[1];
      }

      return null;
    },
  },
  watch: {
    type(newValue, oldValue) {
      if (newValue !== oldValue) {
        // 나중에 손보기로...;;
        setTimeout(() => {
          this.localVisible = this.visible;
        }, 100);
      }
    },
    visible(value) {
      this.localVisible = value;
    },
  },
};
</script>
<style lang="scss">
@import '~@fastcampus/styles/style.scss';

.fc-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: rgba(#000, 0.8);

  color: #000;

  .btn-confirm {
    width: 100%;
    min-height: 4.8rem;
    margin-top: 2.4rem;
    padding: 1.3rem 2.4rem;
    border-radius: 0.4rem;

    background-color: $c-red;

    font-weight: bold;
    font-size: $f-contents;
    color: $c-white;
  }

  .btn-text {
    width: 100%;
    margin-top: 2.4rem;
    padding: 1.3rem 2.4rem;

    font-weight: bold;
    font-size: $f-contents;
    color: $c-body;
  }
}
</style>
